import { useNavigate } from "react-router-dom";
import LockOutlined from "@ant-design/icons/LockOutlined";
import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
import UserOutlined from "@ant-design/icons/UserOutlined";
import { ItemType } from "antd/lib/menu/interface";

import useAuth from "@hooks/useAuth";

import { UserContainer, UserIconWrapper, Menu, MenuText } from "./styles";
import { FC } from "react";

interface Props {
  isMobile?: boolean;
}

export const UserDropdownV2: FC<Props> = ({ isMobile }) => {
  const navigate = useNavigate();
  const { name, onLogout } = useAuth();

  const resetPassword = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigate("/nova-senha");
  };

  const items: ItemType[] = [
    {
      key: "subMenu",
      label: (
        <UserContainer>
          <UserIconWrapper>
            <UserOutlined style={{ fontSize: 18 }} />
          </UserIconWrapper>

          {!isMobile && <MenuText title={name}>{name}</MenuText>}
        </UserContainer>
      ),
      popupOffset: [0],
      children: [
        {
          key: "changePassword",
          icon: <LockOutlined />,
          onClick: resetPassword,
          label: "Alterar Senha",
        },
        {
          key: "logout",
          icon: <LogoutOutlined />,
          onClick: () => onLogout(),
          label: "Sair",
        },
      ],
    },
  ];

  return <Menu items={items} mode="horizontal" disabledOverflow />;
};
